import { useCallback, useMemo, useRef, useState } from 'react';
export function useKanbanBoard(options) {
    const optionsRef = useRef(options);
    optionsRef.current = options;
    const [items, setItems] = useState([]);
    // use key to re-evaluate value when columns are updated
    // and change reference of columns to update from hook deps
    const columnsKey = options.columns
        .map(column => { var _a; return `${column.id}-${column.name}-${(_a = column.state) === null || _a === void 0 ? void 0 : _a.name}`; })
        .join(',');
    const columns = useMemo(() => {
        return Array.from(optionsRef.current.columns);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnsKey]);
    const setup = useCallback(options => {
        const boardColumns = options.columns.filter(boardColumn => {
            return columns.some(column => column.id === boardColumn.id);
        });
        const items = [];
        for (const boardColumn of boardColumns) {
            for (const boardItem of boardColumn.items) {
                const item = optionsRef.current.createItem(boardColumn.id, boardItem);
                items.push(item);
            }
        }
        setItems(items);
        return items;
    }, [columns, setItems]);
    // recreate items
    const refresh = useCallback(() => {
        setItems(items => {
            return items.map(item => {
                return optionsRef.current.createItem(item.columnId, item.data);
            });
        });
    }, []);
    const manager = useMemo(() => {
        return { columns, items, setItems, setup, refresh };
    }, [columns, items, setItems, setup, refresh]);
    return manager;
}
//# sourceMappingURL=useKanbanBoard.js.map